<template>
	<v-app :class="{ 'global-style': $myStore.state.largeFont, 'dyslexic-font': $myStore.state.dyslexicFont }">
		<div v-if="$myStore.state.loaderCount > 0" class="loader">
			<v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
		</div>

		<v-dialog v-model="alertModal.show" max-width="480">
			<v-card>
				<v-card-title></v-card-title>
				<v-card-text color="modalText" v-html="alertModal.text"></v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="primary" @click="alertModal.show = false">{{ $t('buttons.ok') }}</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-dialog v-model="verifyModal.show" max-width="480" persistent>
			<v-card class="pa-4">
				<v-card-text color="modalText" v-html="verifyModal.text"></v-card-text>
				<v-card-actions>
					<v-btn color="primary" @click="verifyModal.result(true)">{{ $t('buttons.yes') }}</v-btn>
					<v-spacer></v-spacer>
					<v-btn color="basicButton" @click="verifyModal.result(false)">{{ $t('buttons.no') }}</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-dialog v-model="promptModal.show" max-width="480" persistent>
			<v-card class="pa-4">
				<v-card-text color="modalText">
					<InputField v-model="promptModal.value" :label="promptModal.text"></InputField>
				</v-card-text>
				<v-card-actions>
					<v-btn color="primary" @click="promptModal.result(true)">{{ $t('buttons.ok') }}</v-btn>
					<v-spacer></v-spacer>
					<v-btn color="basicButton" @click="promptModal.result(false)">{{ $t('buttons.cancel') }}</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-snackbar
			v-model="notification.show"
			:timeout="3000"
			:top="true"
			class="notification black--text text-center"
			color="primary"
			>{{ notification.text }}
		</v-snackbar>

		<template v-if="$myStore.state.loggedIn">
			<v-app-bar app clipped-left dense flat color="appBar">
				<v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
				<v-img
					v-if="$vuetify.theme.dark == false"
					:max-height="40"
					:max-width="110"
					:src="publicPath + 'logo.png'"
					style="cursor: pointer"
					@click="logoClick"
				/>
				<div v-else :class="['d-inline-block', 'logo-styling']">
					<v-img
						:max-height="40"
						:max-width="110"
						:src="publicPath + 'logo.png'"
						style="cursor: pointer"
						@click="logoClick"
					/>
				</div>
				<v-breadcrumbs color="black" :items="$myStore.state.breadcrumbs" divider=">"></v-breadcrumbs>
				<v-spacer></v-spacer>
				<div :class="['subtitle-1', 'grey--text']">
					{{ $myStore.state.user.first_name + ' ' + $myStore.state.user.last_name }}
				</div>
				<v-tooltip bottom>
					<template v-slot:activator="{ on, attrs }">
						<v-btn depressed icon v-bind="attrs" @click="settingsDrawer = !settingsDrawer" v-on="on">
							<v-icon>fa-gear</v-icon>
						</v-btn>
					</template>
					<span>{{ $t('tooltips.settings') }}</span>
				</v-tooltip>
				<v-tooltip bottom>
					<template v-slot:activator="{ on, attrs }">
						<v-btn depressed icon v-bind="attrs" @click="logoutClick" v-on="on">
							<v-icon>fa-sign-out-alt</v-icon>
						</v-btn>
					</template>
					<span>{{ $t('tooltips.logout') }}</span>
				</v-tooltip>
			</v-app-bar>
			<v-navigation-drawer v-model="drawer" app clipped dark>
				<v-list dense>
					<div class="navigation-items">
						<v-list-item :to="{ path: '/gantt' }">
							<v-list-item-icon>
								<v-icon>fas fa-chart-gantt</v-icon>
							</v-list-item-icon>
							<v-list-item-title>{{ $t('modules.gantt') }}</v-list-item-title>
						</v-list-item>
						<v-list-item :to="{ path: '/candidates' }">
							<v-list-item-icon>
								<v-icon>fas fa-user-graduate</v-icon>
							</v-list-item-icon>
							<v-list-item-title>{{ $t('modules.candidates') }}</v-list-item-title>
						</v-list-item>
						<v-list-item :to="{ path: '/issued-certificates' }">
							<v-list-item-icon>
								<v-icon>fas fa-stamp</v-icon>
							</v-list-item-icon>
							<v-list-item-title>{{ $t('modules.issuedCertificates') }}</v-list-item-title>
						</v-list-item>
						<v-list-item :to="{ path: '/planned-courses' }">
							<v-list-item-icon>
								<v-icon>fas fa-map</v-icon>
							</v-list-item-icon>
							<v-list-item-title>{{ $t('modules.plans') }}</v-list-item-title>
						</v-list-item>
						<v-list-item :to="{ path: '/annual-plan' }">
							<v-list-item-icon>
								<v-icon>fas fa-earth-americas</v-icon>
							</v-list-item-icon>
							<v-list-item-title>{{ $t('modules.annualPlan') }}</v-list-item-title>
						</v-list-item>
						<v-list-item :to="{ path: '/teachers' }">
							<v-list-item-icon>
								<v-icon>fas fa-chalkboard-user</v-icon>
							</v-list-item-icon>
							<v-list-item-title>{{ $t('modules.teachers') }}</v-list-item-title>
						</v-list-item>
						<v-list-item :to="{ path: '/payment-contracts' }">
							<v-list-item-icon>
								<v-icon>fas fa-money-check-dollar</v-icon>
							</v-list-item-icon>
							<v-list-item-title>{{ $t('modules.paymentContracts') }}</v-list-item-title>
						</v-list-item>
						<v-list-item :to="{ path: '/weekly-schedule' }">
							<v-list-item-icon>
								<v-icon>fas fa-calendar-days</v-icon>
							</v-list-item-icon>
							<v-list-item-title>{{ $t('modules.weeklySchedule') }}</v-list-item-title>
						</v-list-item>

						<v-list-item :to="{ path: '/surveys' }">
							<v-list-item-icon>
								<v-icon>fas fa-square-check</v-icon>
							</v-list-item-icon>
							<v-list-item-title>{{ $t('modules.surveys') }}</v-list-item-title>
						</v-list-item>
						<v-list-item :to="{ path: '/stats' }" v-if="$myStore.state.user.user_role_id == 1">
							<v-list-item-icon>
								<v-icon>fas fa-chart-simple</v-icon>
							</v-list-item-icon>
							<v-list-item-title>{{ $t('modules.stats') }}</v-list-item-title>
						</v-list-item>
						<v-list-item :to="{ path: '/partners' }">
							<v-list-item-icon>
								<v-icon>fas fa-handshake</v-icon>
							</v-list-item-icon>
							<v-list-item-title>{{ $t('modules.partners') }}</v-list-item-title>
						</v-list-item>
						<v-list-item :to="{ path: '/preregistrations' }">
							<v-list-item-icon>
								<v-icon>fas fa-barcode</v-icon>
							</v-list-item-icon>
							<v-list-item-title>{{ $t('modules.preregistrations') }}</v-list-item-title>
						</v-list-item>
						<v-list-item :to="{ path: '/brevets' }">
							<v-list-item-icon>
								<v-icon>fas fa-repeat</v-icon>
							</v-list-item-icon>
							<v-list-item-title>{{ $t('modules.brevetsRenewal') }}</v-list-item-title>
						</v-list-item>
						<v-list-group no-action active-class="active-nav-group">
							<v-icon left slot="prependIcon" color="dark-grey">fas fa-database</v-icon>
							<v-icon slot="appendIcon" small>fa-chevron-down</v-icon>
							<template v-slot:activator>
								<v-list-item class="pl-0">
									<v-list-item-title>{{ $t('modules.codebooks') }}</v-list-item-title>
								</v-list-item>
							</template>
							<v-list-item
								v-if="$myStore.state.user.user_role_id == 1"
								:to="{ path: '/certificates' }"
								active-class="active-nav-group-item"
							>
								<v-list-item-icon>
									<v-icon>fas fa-certificate</v-icon>
								</v-list-item-icon>
								<v-list-item-title>{{ $t('modules.certificates') }}</v-list-item-title>
							</v-list-item>
							<v-list-item :to="{ path: '/courses' }" active-class="active-nav-group-item">
								<v-list-item-icon>
									<v-icon>fas fa-graduation-cap</v-icon>
								</v-list-item-icon>
								<v-list-item-title>{{ $t('modules.courses') }}</v-list-item-title>
							</v-list-item>
							<v-list-item :to="{ path: '/classrooms' }" active-class="active-nav-group-item">
								<v-list-item-icon>
									<v-icon>fas fa-school</v-icon>
								</v-list-item-icon>
								<v-list-item-title>{{ $t('modules.classrooms') }}</v-list-item-title>
							</v-list-item>
							<v-list-item
								v-if="$myStore.state.user.user_role_id == 1"
								:to="{ path: '/ships' }"
								active-class="active-nav-group-item"
							>
								<v-list-item-icon>
									<v-icon>fas fa-sailboat</v-icon>
								</v-list-item-icon>
								<v-list-item-title>{{ $t('modules.ships') }}</v-list-item-title>
							</v-list-item>
							<v-list-item
								v-if="$myStore.state.user.user_role_id == 1"
								:to="{ path: '/codebooks' }"
								active-class="active-nav-group-item"
							>
								<v-list-item-icon>
									<v-icon>fas fa-server</v-icon>
								</v-list-item-icon>
								<v-list-item-title>{{ $t('modules.otherCodebooks') }}</v-list-item-title>
							</v-list-item>
						</v-list-group>
						<v-divider></v-divider>
						<v-list-group no-action active-class="active-nav-group">
							<v-icon slot="prependIcon" color="dark-grey">fas fa-briefcase</v-icon>
							<v-icon slot="appendIcon" small>fa-chevron-down</v-icon>
							<template v-slot:activator>
								<v-list-item class="pl-0 pr-0">
									<v-list-item-title>{{ $t('modules.administration') }}</v-list-item-title>
								</v-list-item>
							</template>
							<v-list-item :to="{ path: '/profile' }" active-class="active-nav-group-item">
								<v-list-item-icon>
									<v-icon>fas fa-address-card</v-icon>
								</v-list-item-icon>
								<v-list-item-title>{{ $t('modules.profile') }}</v-list-item-title>
							</v-list-item>
							<v-list-item :to="{ path: '/internal-documents' }" active-class="active-nav-group-item">
								<v-list-item-icon>
									<v-icon>fas fa-file-word</v-icon>
								</v-list-item-icon>
								<v-list-item-title>{{ $t('modules.internalDocuments') }}</v-list-item-title>
							</v-list-item>
							<v-list-item :to="{ path: '/equipments' }" active-class="active-nav-group-item">
								<v-list-item-icon>
									<v-icon>fas fa-computer</v-icon>
								</v-list-item-icon>
								<v-list-item-title>{{ $t('modules.equipments') }}</v-list-item-title>
							</v-list-item>
							<v-list-item
								:to="{ path: '/contracts' }"
								v-if="$myStore.state.user.user_role_id == 1"
								active-class="active-nav-group-item"
							>
								<v-list-item-icon>
									<v-icon>fas fa-file-signature</v-icon>
								</v-list-item-icon>
								<v-list-item-title>{{ $t('modules.contracts') }}</v-list-item-title>
							</v-list-item>
							<v-list-item
								:to="{ path: '/user-accounts' }"
								v-if="$myStore.state.user.user_role_id == 1"
								active-class="active-nav-group-item"
							>
								<v-list-item-icon>
									<v-icon>fas fa-users</v-icon>
								</v-list-item-icon>
								<v-list-item-title>{{ $t('modules.userAccounts') }}</v-list-item-title>
							</v-list-item>
						</v-list-group>
					</div>
					<div class="menu-footer">
						<v-row class="d-flex justify-space-between">
							<v-col cols="1" class="pa-0 ma-0"> </v-col>
							<v-col cols="8" class="pa-0">
								<div v-html="$getSettings('FOOTER_HTML')"></div>
							</v-col>
							<v-col cols="2" class="d-flex align-center pa-0 mr-4">
								<v-tooltip right>
									<template v-slot:activator="{ on, attrs }">
										<v-btn
											depressed
											small
											icon
											v-bind="attrs"
											@click="getUserManual"
											v-on="on"
											class="pb-2"
										>
											<v-icon>fa-circle-info</v-icon>
										</v-btn>
									</template>
									<span>{{ $t('tooltips.userManual') }}</span>
								</v-tooltip>
							</v-col>
						</v-row>
					</div>
				</v-list>
			</v-navigation-drawer>
			<v-navigation-drawer temporary right app v-model="settingsDrawer" width="300">
				<AccessibilitySettings :drawer="settingsDrawer" @closeSettings="closeSettings"></AccessibilitySettings>
			</v-navigation-drawer>
		</template>
		<v-main v-if="initialLoadCompleted">
			<transition name="fade">
				<router-view></router-view>
			</transition>
		</v-main>
	</v-app>
</template>

<script>
import InputField from './components/trinkets/InputField';
import AccessibilitySettings from './components/trinkets/AccessibilitySettings';
import '@/assets/styles/dyslexic-font.css';

export default {
	name: 'App',
	components: { InputField, AccessibilitySettings },
	data() {
		return {
			drawer: null,
			settingsDrawer: null,
			larger_font: false,
			alertModal: {
				show: false,
				text: '',
			},
			verifyModal: {
				show: false,
				text: '',
				result: (result) => {
					this.verifyModal.show = false;
					this.verifyModal.reaction(result);
				},
				reaction: () => {},
			},
			promptModal: {
				show: false,
				text: '',
				value: '',
				result: (result) => {
					this.promptModal.show = false;
					if (result !== false) {
						this.promptModal.reaction(this.promptModal.value);
					} else {
						this.promptModal.reaction(false);
					}
				},
				reaction: () => {},
			},
			notification: {
				show: false,
				text: '',
			},
			initialLoadCompleted: false,
			breadcrumbs: [],
			publicPath: process.env.BASE_URL,
		};
	},
	computed: {},
	methods: {
		logoutClick() {
			let vm = this;
			this.$APICall('post', 'logout', {}, (data, success) => {
				if (success) {
					vm.$myStore.commit('setUser', null);
					vm.$myStore.commit('setLoggedIn', false);
					vm.$router.push('/login');
				}
			});
		},
		getUserManual() {
			this.$APICall('get', 'user-manual', {}, (data, success) => {
				if (success) {
					window.open(data.link);
				}
			});
		},
		closeSettings() {
			this.settingsDrawer = false;
		},
		profileClick() {
			this.$router.push('/profile');
		},
		logoClick() {
			this.$router.push('/gantt');
		},
		showPDF(fileName) {
			window.open(process.env.BASE_URL + fileName + '.pdf');
		},
	},
	mounted() {
		var vm = this;

		this.$modalBus.$on('ALERT', (message) => {
			vm.alertModal.text = message;
			vm.alertModal.show = true;
		});
		this.$modalBus.$on('VERIFY', (data) => {
			vm.verifyModal.text = data.message;
			vm.verifyModal.reaction = data.response;
			vm.verifyModal.show = true;
		});
		this.$modalBus.$on('PROMPT', (data) => {
			vm.promptModal.text = data.message;
			vm.promptModal.value = data.initial;
			vm.promptModal.reaction = data.response;
			vm.promptModal.show = true;
		});
		this.$modalBus.$on('NOTIFY', (message) => {
			vm.notification.text = message;
			vm.notification.show = true;
		});

		if (/^\/candidate-survey\/[\w\d]+$/.test(this.$route.path)) {
			this.$myStore.commit('setUser', null);
			this.$myStore.commit('setLoggedIn', false);
			this.initialLoadCompleted = true;
		} else {
			this.$APICall('get', 'session', {}, (data, success) => {
				if (success) {
					vm.$myStore.commit('setUser', data);
					vm.$vuetify.theme.dark = data.dark_theme;
					vm.$myStore.commit('setLargeFont', data.large_font);
					vm.$myStore.commit('setDyslexicFont', data.dyslexic_font);
					vm.$myStore.commit('setLoggedIn', true);
					let baseRoutes = ['login', null];
					if (baseRoutes.indexOf(vm.$router.currentRoute.name) !== -1) {
						vm.$router.push('/gantt');
					}
					vm.initialLoadCompleted = true;
					if (data.version != vm.$getCookie('ide3_version')) {
						vm.$setCookie('ide3_version', data.version, 30);
						window.location.reload(true);
					}
				} else {
					vm.$APICall('get', 'version', {}, (data, success) => {
						if (success) {
							if (data.version != vm.$getCookie('ide3_version')) {
								vm.$setCookie('ide3_version', data.version, 30);
								window.location.reload(true);
							}
							vm.$myStore.commit('setUser', null);
							vm.$myStore.commit('setLoggedIn', false);
							vm.$router.replace('/login');
							vm.initialLoadCompleted = true;
						}
					});
				}
			});
		}
	},
};
</script>

<style>
.logo-styling {
	background-color: #666666;
	padding: 10px;
}
.navigation-items {
	margin-bottom: 50px;
}
.notification {
	z-index: 999999;
}

.loader {
	position: fixed;
	left: 0px;
	top: 0px;
	z-index: 999;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.3);
	font-size: 100px;
	text-align: center;
	padding-top: 100px;
}

.fade-enter {
	opacity: 0;
}

.fade-enter-active {
	transition: opacity 1s;
}

.fade-to {
	opacity: 1;
}

.cursor-pointer {
	cursor: pointer;
}

.global-style .v-input {
	font-size: 22px;
}

.global-style .v-label {
	font-size: 20px;
	height: 100%;
}

.global-style .v-btn,
.global-style .v-tab,
.global-style .v-card__text,
.global-style .v-data-table {
	font-size: 1.1rem;
}

.global-style .v-card__title {
	font-size: 1.5rem;
}

.global-style .v-breadcrumbs li {
	font-size: 18px;
}

.global-style .text-subtitle-1,
.global-style .text-body-1 {
	font-size: 1.2rem !important;
}

.global-style .navigation-items .v-list-item .v-list-item__title {
	font-size: 1rem !important;
	height: 100%;
}

.global-style .v-list-item__title,
.global-style .subtitle-1 {
	font-size: 1.2rem !important;
}

.global-style .text-h6 {
	font-size: 1.45rem !important;
}

.global-style .text-h5 {
	font-size: 1.7rem !important;
}

.global-style .v-data-table > .v-data-table__wrapper > table > tbody > tr > td,
.v-data-table > .v-data-table__wrapper > table > thead > tr > td,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr > td {
	font-size: 1.1rem;
}

.global-style .v-calendar .v-event-timed {
	font-size: 16px;
}

.global-style .v-application--is-ltr .v-list-item__action:last-of-type:not(:only-child),
.v-application--is-ltr .v-list-item__avatar:last-of-type:not(:only-child),
.v-application--is-ltr .v-list-item__icon:last-of-type:not(:only-child) {
	margin-left: 0px;
}

.v-application--is-ltr .v-list-group--no-action > .v-list-group__items > .v-list-item {
	padding-left: 48px;
}

.menu-footer {
	position: fixed;
	bottom: 10px;
	width: 100%;
	text-align: center;
}

.global-style .menu-footer {
	font-size: 18px;
}

.dyslexic-font .v-card,
.dyslexic-font .v-card__text,
.dyslexic-font .v-list-item,
.dyslexic-font .v-event-timed,
.dyslexic-font .v-breadcrumbs,
.dyslexic-font .v-btn,
.dyslexic-font .v-data-table,
.dyslexic-font .v-tab,
.dyslexic-font .text-h6,
.dyslexic-font .text-h5,
.dyslexic-font .text-body-1,
.dyslexic-font .subtitle-1,
.dyslexic-font .text-subtitle-1,
.dyslexic-font .menu-footer,
.dyslexic-font .v-tooltip__content {
	font-family: 'OpenDyslexic', sans-serif !important;
}

.active-nav-group,
.active-nav-group-item {
	caret-color: #666666 !important;
	color: white !important;
}

.menu-footer a {
	text-decoration: none;
}
</style>
